import api from '@pray/shared/utils/api';

import type { MarketingCampaignStatus, MarketingCampaignBudgetType } from './getAllMarketingCampaigns';

export type UpdateMarketingCampaignParams = {
  artistId: string;
  campaignId: string;
  name?: string;
  description?: string;
  status?: MarketingCampaignStatus;
  budgetType?: MarketingCampaignBudgetType;
  totalBudgetCents?: number;
  contractValueCents?: number;
  // Changing the fee re-prices the same contract face, so the server re-derives the stored
  // pre-fee total from it. Editing contractValueCents alone stays records-only by design.
  serviceFeePercent?: number;
  dailyBudgetCents?: number;
  startDate?: string;
  endDate?: string;
  // The signed term, amended only when the contract is. Sending startDate/endDate leaves these
  // alone server-side, so moving delivery never restates recognized revenue.
  // null/null explicitly clears the stored term; undefined leaves it untouched.
  contractStartDate?: string | null;
  contractEndDate?: string | null;
  placements?: string[];
  platforms?: string[];
  newArtistId?: string;
};

export const updateMarketingCampaign = async ({
  artistId,
  campaignId,
  name,
  description,
  status,
  budgetType,
  totalBudgetCents,
  contractValueCents,
  serviceFeePercent,
  dailyBudgetCents,
  startDate,
  endDate,
  contractStartDate,
  contractEndDate,
  placements,
  platforms,
  newArtistId,
}: UpdateMarketingCampaignParams) => {
  const url = `/web/studio/artists/${artistId}/marketing-campaigns/${campaignId}`;

  const body: Record<string, unknown> = {};

  if (name !== undefined) body.name = name;
  if (description !== undefined) body.description = description;
  if (status !== undefined) body.status = status;
  if (budgetType !== undefined) body.budget_type = budgetType;
  if (totalBudgetCents !== undefined) body.total_budget_cents = totalBudgetCents;
  if (contractValueCents !== undefined) body.contract_value_cents = contractValueCents;
  if (serviceFeePercent !== undefined) body.service_fee_percent = serviceFeePercent;
  if (dailyBudgetCents !== undefined) body.daily_budget_cents = dailyBudgetCents;
  if (startDate !== undefined) body.start_date = startDate;
  if (endDate !== undefined) body.end_date = endDate;
  if (contractStartDate !== undefined) body.contract_start_date = contractStartDate;
  if (contractEndDate !== undefined) body.contract_end_date = contractEndDate;
  if (placements !== undefined) body.placements = placements;
  if (platforms !== undefined) body.platforms = platforms;
  if (newArtistId !== undefined) body.artist_id = newArtistId;

  const response = await api.executePutRequest(url, body);

  return response.data;
};
